import React from 'react';
import { styled } from '@linaria/react';
import { useTheme, ITheme } from 'src/theme';

const Container = styled.div<{theme: ITheme}>`
  width: 100%;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 13px;
    height: 13px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${props => props.theme?.colors.grey[1000]};
    border-radius: 20px;
  } 
  &::-webkit-scrollbar-thumb {
    height: 120px;
    border-radius: 20px;
    border: 2px solid ${props => props.theme?.colors.grey[1000]};
    background-color: ${props => props.theme?.colors.secondary};
    background-clip: padding-box;
  }
`

const TableContainer = styled.table<StyledProps>`
  border: 0px solid #CCC;
  border-collapse: collapse;
  width: 100%;
`;

const TR = styled.tr<StyledProps>`
  padding: 8px 20px;
  border: none;
  background-color: ${props => props.type === 'header' ?
    props.theme.colors.primary :
    (props.type === 'row-odd' ? props.theme.colors.grey[600] : props.theme.colors.white)
  };

`
const TH = styled.th<StyledProps>`
  color: ${props => props.theme.colors.white};
  white-space: nowrap;
  font-size: ${props => props.theme.fontSize.text};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  padding: 8px 15px 8px 0px;
  border: none;
  text-align: left;
  &:first-child {
    padding-left: 10px;
  }
  @media screen and (min-width: 768px) {
    text-align: left;
  }

`
const TD = styled.td<StyledProps>`
  font-size: ${props => props.theme.fontSize.text};
  font-weight: ${props => props.isKey ? 'bold' : 'normal'};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  white-space: nowrap;
  padding: 10px 0;
  color: ${props => props.theme.colors.grey[500]};
  border: none;
  &:first-child {
    padding-left: 10px;
  }
`

const ContentBox = styled.td<StyledProps>`
  display: inline-block;
  padding-right: 20px;
`

interface StyledProps {
  theme: ITheme,
  type?: 'header' | 'row-odd' | 'row-even',
  isKey?: boolean;
}

export interface TableProps {
  theme?: ITheme,
  header: any[];
  source: any[];
}

function Table({ header, source }: TableProps) {
  const theme = useTheme();
  const keys = header.map((item: any) => item.id);

  const renderHeader = () => {
    return (
      <TR theme={theme} type="header">
        {header.map((item: any, index: number) => (<TH theme={theme} key={`${index}`}>{item.label}</TH>))}
      </TR>
    );
  };

  const renderBody = () => {
    return source.map((item: any, index: number) => {
      const { data } = item;
      const typeRow = index % 2 === 0 ? 'row-even' : 'row-odd';
      return (
        <React.Fragment key={`${index}`}>
          <TR type={typeRow} theme={theme}>
            {item.key && <TD isKey theme={theme}><ContentBox theme={theme}>{item.key}</ContentBox></TD>}
            {keys.map(key => <TD key={key} theme={theme}></TD>)}
          </TR>
          {
            data.map((row: any, rowIndex: number) => {
              return (
                <TR key={rowIndex} type={typeRow} theme={theme}>
                  {keys.map((key: string, cellIndex: number) => {
                    return <TD theme={theme} key={`${rowIndex}-${cellIndex}`}><ContentBox theme={theme}>{row[key]}</ContentBox></TD>
                  })}
                </TR>
              )
            })
          }

        </React.Fragment>
      )
    });
  }
  return (
    <Container theme={theme}>
      <TableContainer theme={theme}>
        <thead>
          {renderHeader()}
        </thead>
        <tbody>
          {renderBody()}
        </tbody>
      </TableContainer>
    </Container>

  );
};

Table.defaultProps = {
  header: [],
  source: []
}

export default Table;
